import doMatchedRoutesMatch from 'app/common/middlewares/utils/doMatchedRoutesMatch';

const shouldScrollToTopForMatchedRoutes = doMatchedRoutesMatch(route => {
  return !!route.shouldScrollToTop;
});

export default shouldScrollToTopForMatchedRoutes;
